
ADILF.define('adilf/debug',['require','exports','module'],function (require, exports, module) {/* Utility: Debug object */
"use strict";

var Debug = function(label, active) {
    var self = this;
    self.label = label || "Debug" + Math.floor(Math.random() * 100);
    self.active = active || Debug.environmentDebug();
    Debug.instances.push(self);
};

Debug.instances = [];

/* istanbul ignore next */
Debug.environmentDebug = function() {
    return (window.location.hash == "#lfdebug");
};

Debug.prototype.print = function() {
    var self = this;
    if(arguments && self.active) {
        var msg = self._format(arguments);
        console.log(msg[0], msg[1]);
    }
};

Debug.prototype.warn = function() {
    var self = this;
    /* istanbul ignore else */
    if(arguments && console.warn) {
        var msg = self._format(arguments);
        console.warn("WARNING :: ", msg[0], msg[1]);
    }
};

Debug.prototype.error = function() {
    var self = this;
    /* istanbul ignore else */
    if(arguments && console.error) {
        var msg = self._format(arguments);
        console.error("ERROR :: ", msg[0], msg[1]);
    }
};

Debug.prototype._format = function() {
    var self = this;
    var args = [].splice.call(arguments[0], 0); // Convert to array
    var label = "Social :: " + self.label + " ::";
    if(args.length == 1) {
        args = args[0];
    } else {
        label += " "+args[0];
        args.splice(0, 1);
    }
    return [label, args];
};

Debug.prototype.set = function(val) {
    var self = this;
    self.active = !!val;
    return self.active;
};

Debug.prototype.toggle = function(val) {
    var self = this;
    if(val !== undefined) { return self.set(val); }
    self.active = (self.active) ? false : true;
    return self.active;
};

Debug.prototype.all = function(val) {
    var self = this;
    for(var i=0; i<Debug.instances.length; i++) {
        Debug.instances[i].set(val);
    }
};

module.exports = Debug;
});
